import { render, staticRenderFns } from "./carmwtwopassrecord.vue?vue&type=template&id=66f65154&"
import script from "./carmwtwopassrecord.vue?vue&type=script&lang=js&"
export * from "./carmwtwopassrecord.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports